class HeaderSearch extends window.BAO.CustomElement() {
  constructor () {
    super()

    // Tracks whether the menu was open when search was opened
    this.openedFromMenu = false
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.handleFocusIn = this.handleFocusIn.bind(this)

    if (this.triggerEl) {
      this.listeners.add(this.triggerEl, 'click', this.handleTriggerClick)
    }

    this.externalEls.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTriggerClick)
    })

    if (this.closeEl) {
      this.listeners.add(this.closeEl, 'click', this.handleCloseClick)
    }

    this.listeners.add(document, 'click', this.handleDocumentClick)
    this.listeners.add(document, 'keyup', this.handleKeyUp)
    this.listeners.add(document, 'focusin', this.handleFocusIn)
  }

  handleTriggerClick (event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
      return
    }

    // Remember if the search was opened while the mobile menu was open
    this.openedFromMenu = this.drawers?.activeDrawerKey === 'menu'

    if (this.openedFromMenu) {
      // Close the menu before opening the search overlay
      this.drawers.closeDrawer()
    }

    this.open()
  }

  handleCloseClick () {
    this.close()
  }

  handleDocumentClick (event) {
    const target = event.target
    const closeEl = this.closeEl

    if (closeEl && closeEl.contains(target)) {
      this.close()
      return
    }

    if (!this.isOpen) return

    if (this.contains(target)) return
    if (this.panelEl?.contains(target)) return

    this.close()
  }

  handleFocusIn (event) {
    if (!this.isOpen) return

    if (event.target !== this.menuTriggerEl) return

    this.inputEl?.focus()
  }

  handleKeyUp (event) {
    if (!this.isOpen || event.code?.toUpperCase() !== 'ESCAPE') return

    this.close()
    this.triggerEl?.focus()
  }

  open () {
    if (!this.panelEl || !this.triggerEl) return

    this.panelEl.setAttribute('aria-hidden', 'false')
    this.triggerEl.setAttribute('aria-expanded', 'true')
    document.body.classList.add('hide--scroll')

    this.inputEl?.focus()
  }

  close () {
    if (!this.panelEl || !this.triggerEl) return

    this.panelEl.setAttribute('aria-hidden', 'true')
    this.triggerEl.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('hide--scroll')

    if (this.openedFromMenu) {
      // Reopen the mobile menu if it was open before search
      this.openedFromMenu = false

      this.drawers?.open('menu', this.menuTriggerEl)
    }
  }

  get triggerEl () {
    return this.els.trigger?.element || this.externalEls.trigger?.element
  }

  get closeEl () {
    return this.els.close?.element || this.externalEls.close?.element
  }

  get inputEl () {
    return this.els.input?.element || this.externalEls.input?.element
  }

  get panelEl () {
    if (this.els.panel?.exists) return this.els.panel.element
    if (this.externalEls.panel?.exists) return this.externalEls.panel.element

    const controlledPanelId = this.triggerEl?.getAttribute('aria-controls')

    return controlledPanelId ? document.getElementById(controlledPanelId) : null
  }

  // Access the existing site drawers controller
  get drawers () {
    return window.drawers
  }

  // Get the menu drawer's existing trigger through the BAO drawer API
  get menuTriggerEl () {
    return this.drawers?.drawers
      ?.find((drawer) => drawer.key === 'menu')
      ?.elements.trigger
  }

  get isOpen () {
    return this.panelEl?.getAttribute('aria-hidden') === 'false'
  }
}

if (!customElements.get('header-search')) {
  customElements.define('header-search', HeaderSearch)
}
